export { PLUGIN_KEY, PLUGIN_PRIORITY, MultipleSelectionHandles } from "./multipleSelectionHandles.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/multipleSelectionHandles/index.mjs
// module id = 1502
// module chunks = 1